import { costGuide_costGuide_CostGuideSuccess_costGuide_rates_averageRate_averageHourlyRate as AverageHourlyRateType } from '@/__generated__/costGuide';

export interface CostGuidPriceSpecificationSchemaProps {
  averageHourlyRate: AverageHourlyRateType;
}

const CostGuidePriceSpecificationSchema = ({
  averageHourlyRate,
}: CostGuidPriceSpecificationSchemaProps) => {
  const avgHourlyRate = parseFloat(averageHourlyRate.rate.amount).toFixed(2);

  const currentDate = new Date();
  const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const costGuidePriceSpecificationSchema = {
    '@context': 'https://schema.org',
    '@type': 'PriceSpecification',
    price: `${avgHourlyRate}/hour`,
    priceCurrency: 'USD',
    validFrom: firstDateOfMonth.toISOString(),
    validThrough: lastDateOfMonth.toISOString(),
  };

  return (
    <script
      data-testid="costGuidePriceSpecificationSchema"
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(costGuidePriceSpecificationSchema) }}
    />
  );
};

export { CostGuidePriceSpecificationSchema };
